import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreadError = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 166,
	height: 166,
	viewBox: "0 0 166 166",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M165.905 83C165.905 128.787 128.787 165.905 83 165.905C37.2131 165.905 0.0954023 128.787 0.0954023 83C0.0954023 37.2131 37.2131 0.0954023 83 0.0954023C128.787 0.0954023 165.905 37.2131 165.905 83Z",
			fill: "url(#paint0_radial_82_55933)",
			fillOpacity: .2,
			stroke: "#561090",
			strokeWidth: .190805
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M141.005 82.9998C141.005 115.088 114.993 141.1 82.9051 141.1C50.8174 141.1 24.8051 115.088 24.8051 82.9998C24.8051 50.9121 50.8174 24.8998 82.9051 24.8998C114.993 24.8998 141.005 50.9121 141.005 82.9998Z",
			fill: "url(#paint1_radial_82_55933)",
			fillOpacity: .4,
			stroke: "#561090",
			strokeWidth: .190805
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_bddi_82_55933)",
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 83.1575,
				cy: 83.1585,
				rx: 36.3521,
				ry: 36.3521,
				fill: "white",
				fillOpacity: .8,
				shapeRendering: "crispEdges"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.3719 68.7443L99.4608 94.8798C99.5998 95.1206 99.673 95.3937 99.673 95.6718C99.673 95.9498 99.5998 96.223 99.4608 96.4637C99.3218 96.7045 99.1219 96.9045 98.8811 97.0435C98.6403 97.1826 98.3671 97.2557 98.0891 97.2558H67.9113C67.6333 97.2557 67.3601 97.1826 67.1194 97.0435C66.8786 96.9045 66.6786 96.7045 66.5396 96.4637C66.4006 96.223 66.3274 95.9498 66.3274 95.6718C66.3274 95.3937 66.4006 95.1206 66.5396 94.8798L81.6285 68.7443C81.7675 68.5035 81.9675 68.3036 82.2083 68.1646C82.449 68.0256 82.7222 67.9524 83.0002 67.9524C83.2782 67.9524 83.5514 68.0256 83.7922 68.1646C84.0329 68.3036 84.2329 68.5035 84.3719 68.7443ZM81.4162 89.3359V92.5038H84.5842V89.3359H81.4162ZM81.4162 78.2481V86.168H84.5842V78.2481H81.4162Z",
			fill: "#D43548"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_bddi_82_55933",
				x: 20.1947,
				y: 37.3026,
				width: 125.925,
				height: 125.925,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 2.37595
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_82_55933"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .475191 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_82_55933",
						result: "effect2_dropShadow_82_55933"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 17.1069 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 13.3053 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_82_55933",
						result: "effect3_dropShadow_82_55933"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_82_55933",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.80153 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect4_innerShadow_82_55933"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_82_55933",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(83 83) rotate(90) scale(83 83)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_82_55933",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(82.9051 82.9998) rotate(90) scale(58.1954 58.1954)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgThreadError);
export default ForwardRef;
